// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import slide1 from "../Assets/2.png"
import slide2 from "../Assets/WhatsApp-Image-2025-02-21-at-10.35.27-PM.jpeg"
import slide3 from "../Assets/gall15.jpg"
import slide4 from "../Assets/gall12.jpg"
import slide5 from "../Assets/slider12.jpg"
import slide6 from "../Assets/slide11.jpg"
import slide7 from "../Assets/gall14.jpg"
import slide8 from "../Assets/pic16.jpg"
import slide9 from "../Assets/pic13.jpg"
import slide10 from "../Assets/pic18.jpg"
import slide11 from "../Assets/pic12.jpg"
import slide12 from "../Assets/pic10.jpg"
import slide13 from "../Assets/slide10.jpg"


function Home() {
    const [current, setCurrent] = useState(0);

    const images = [
        slide1,
        slide2,
        slide3,
        slide4,
        slide5,
        slide6,
        slide7,
        slide8,
        slide9,
        slide10,
        slide11,
        slide12,
        slide13
    ];


    const prevSlide = () => {
        setCurrent(current === 0 ? images.length - 1 : current - 1);
    };

    const nextSlide = () => {
        setCurrent(current === images.length - 1 ? 0 : current + 1);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 3000);
        return () => clearInterval(timer);
    }, [current]);

    return (
        <div className="min-h-screen bg-white">
            {/* Main Content Layout */}
            <main className="flex flex-col md:flex-row gap-6">
                {/* Sidebar (Latest News) */}
                <aside className="w-full md:w-1/4 bg-gray-50 border rounded shadow">
                    <h2 className="text-lg font-bold text-gray-200 mb-4 bg-purpleNew p-2">FOLLOW:</h2>
                    <div className="space-y-4 text-sm p-4">
                        <div>
                        <h3 className="text-black text-sm font-semibold font-serif">LATEST NEWS:</h3>
                            <h3 className="text-newsOrange text-2xl">Latest Article</h3>
                            <p className="mt-1">
                            ⏩ Congratulations Prof. Navin Kumar, Saroj Kumar and Praveer
                                Shiota Latest Research Article in “BONE-Journal” (Online Date:
                                December 16, 2024). <a className="text-gray-500 text-sm" href="https://www.sciencedirect.com/science/article/pii/S8756328224003648?via%3Dihub/"  target="_blank"> Click to see (Click Here for Quick )</a>
                            </p>
                        </div>
                        <div>
                            <h3 className="text-newsOrange text-2xl ">
                                Latest New (Apply Now)
                            </h3>
                            <p className="mt-1">
                            ⏩ JRF Opportunity for Meritorious Students (Last Date:
                                September 1, 2024).
                                <a className="text-gray-500 text-sm" href="/navin/news"  target="_blank"> Click to see (Apply Here Quick)</a>
                            </p>
                        </div>
                        <div>
                            <h3 className="text-newsOrange text-2xl">
                                Latest New (Apply Now)
                            </h3>
                            <p className="mt-1">
                            ⏩ Internship Opportunity for Meritorious Students.
                            <a className="text-gray-500 text-sm" href="/navin/news"  target="_blank"> Click to see (Apply Here Quick)</a>
                            </p>
                            
                        </div>
                        <div>
                            
                            <p className="mt-1">
                            ⏩ Congratulations Prof. Navin Kumar and Piyush Uniyal!
                            <a className="text-gray-500 text-sm" href="https://www.sciencedirect.com/science/article/pii/S0021929022003153?via%3Dihub"  target="_blank"> Click to see </a>
                            </p>
                        </div>

                        <div>
                            <p className="mt-1">
                            ⏩ Follow Prof. Navin Kumar Scopus profile to get updates.
                            <a className="text-gray-500 text-sm" href="https://www.scopus.com/authid/detail.uri?authorId=57194127100"  target="_blank"> Click to see </a>
                            </p>
                        </div>
                    
                        <div>
                            <p className="mt-1">
                            ⏩ Congratulations, Prof.Navin Kumar and Team got appreciation from 'The Journal of Clinical Endocrinology & Metabolism' for publishing highly cited work on "Investigation of mechanical, material and compositional determinants of human trabecular bone quality in type 2 diabetes.
                            <a className="text-gray-500 text-sm" href="https://academic.oup.com/jcem/article/106/5/e2271/6105059?login=true"  target="_blank"> Click to see </a>
                            </p>
                        </div>

                        <div>
                            <p className="mt-1">
                            ⏩ Congratulations, we published new quality paper on 'Effects of type 2 diabetes on the viscoelastic behavior of human trabecular bone.
                            <a className="text-gray-500 text-sm" href="https://www.sciencedirect.com/science/article/pii/S1350453322000595?via%3Dihub"  target="_blank"> Click to see </a>
                            </p>
                        </div>

                        <div>
                            <p className="mt-1">
                            ⏩  Congratulations, we published new quality paper on 'Stochastic failure analysis of proximal femur using an isogeometric analysis based nonlocal gradient-enhanced damage model.
                            <a className="text-gray-500 text-sm" href="https://www.sciencedirect.com/science/article/pii/S0169260722002024?via%3Dihub"  target="_blank"> Click to see </a>
                            </p>
                        </div>
                    
                        
                        
                        <p>
                        ⏩ Dr.Ram Naresh Yadav has been selected for Postdoctoral Fellowship in Bone & Joint Center, Department of Orthopedic Surgery,  Henry Ford Health, USA.
                        </p>
                        <p>
                        ⏩ Dr.Praveer Sihota has been selected for Postdoctoral Fellowship (supported by AvH foundation) in Department of Osteology and Biomechanics (IOBM),  University Medical Center Hamburg-Eppendorf Lottestraße 55a, 22529 Hamburg, Germany.
                        </p>
                        <p>
                        ⏩ Dr.Piyush Lakhani has been selected for Postdoctoral Fellowship in Heriot Watt University, Scotland.
                        </p>
                        <p>
                        ⏩ Dr.Abhimanyu Kiran has been selected for Postdoctoral Fellowship in Glasgow University, Scotland.
                        </p>
                    </div>
                </aside>

                {/* Main Section */}
                <section className="flex-1 p-4">
                    {/* Image Carousel Placeholder */}
                    <div className="relative w-full mx-auto">
                        {/* Image */}
                        <img
                            src={images[current]}
                            alt={`Slide ${current + 1}`}
                            className="w-full rounded shadow rounded-md "  
                        />

                        {/* Left/Right buttons */}
                        <button
                            onClick={prevSlide}
                            className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-gray-700 text-white p-2 rounded-full hover:bg-gray-800"
                        >
                            &#10094;
                        </button>
                        <button
                            onClick={nextSlide}
                            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-gray-700 text-white p-2 rounded-full hover:bg-gray-800"
                        >
                            &#10095;
                        </button>

                        {/* Dots */}
                        <div className="flex justify-center mt-2 space-x-2 mt-4 mb-4">
                            {images.map((_, index) => (
                                <span
                                    key={index}
                                    className={`w-3 h-3 rounded-full ${index === current ? "bg-gray-700" : "bg-gray-300"
                                        }`}
                                ></span>
                            ))}
                        </div>
                    </div>

                    {/* Welcome Section */}
                    <div>
                        <h2 className="text-4xl mb-3 text-gray-700 font-serif">
                            Welcome to Prof. Navin Kumar Research Group, IIT Ropar
                        </h2>
                        <p className="text-gray-700 leading-relaxed font-serif">
                            Our research interests are related to vibration and noise, fault diagnosis and condition monitoring, biomechanics of hard and soft tissue, biomedical instrumentation, smart structures and materials. Our labs are dedicated in the area of Bio and Nano materials engineering with a focus on the combined experimental characterization as well as computational analysis of mechanical properties, stress/strain, and microstructure of engineering and biological materials and their applications in advancing manufacturing and materials processing technologies, engineering design analyses, and biomedical sciences and engineering. Another lab is focusing on investigating and developing advanced methods for active and passive noise and vibration control systems. All of the experiments are designed to demonstrate physical principles and applications to give experience with widely-used tools and techniques in sound and vibration engineering.
                        </p>
                    </div>
                </section>
                
            </main>


        </div>
    );
}

export default Home;
